export const endpoints = {
  labRoutingEndpoint: '/supplier-web/lab-routing/privateorders',
  frameSearchPartialEndpoint: '/catalogframe-consumption-api/frames',
  lensEndpoints: {
    lensSpectaclesEndpoint: '/cataloglens-consumption-api/spectaclelenses',
    lensSpectaclesSummaryEndpoint:
      '/cataloglens-consumption-api/spectaclelenses/summaries',
    lensVisionTypesEndpoint: '/cataloglens-consumption-api/lensvisiontypes',
    lensMaterialTypesEndpoint: '/cataloglens-consumption-api/lensmaterialtypes',
    miscellaneousEndpoints: {
      lensTintColorsEndpoint:
        '/cataloglens-consumption-api/labservices/miscellaneousservices/tintcolors',
      lensTintTypesEndpoint:
        '/cataloglens-consumption-api/labservices/miscellaneousservices/tinttypes',
      lensMirrorSkiCoatingsEndpoint:
        '/cataloglens-consumption-api/labservices/miscellaneousservices/mirrorskicoatings',
      lensUvCoatingsEndpoint:
        '/cataloglens-consumption-api/labservices/miscellaneousservices/uvcoatings',
      lensEdgesEndpoint:
        '/cataloglens-consumption-api/labservices/miscellaneousservices/edges',
      lensBevelEndpoint:
        '/cataloglens-consumption-api/labservices/miscellaneousservices/bevel',
      lensGlassCoatingsEndpoint:
        '/cataloglens-consumption-api/labservices/miscellaneousservices/glasscoatings',
    },
    lensArCoatingsEndpoint:
      '/cataloglens-consumption-api/labservices/arcoatings',
    lensScratchCoatingsEndpoint:
      '/cataloglens-consumption-api/labservices/scratchcoatings',
    lensMiscCoatingsEndpoint:
      '/cataloglens-consumption-api/labservices/miscellaneousservices/miscellaneous',
  },
  labOrderEndpoint: '/lab-laborderapi-web/laborders',
  searchLabOrdersEndpoint: '/lab-laborderapi-web/labordersearchrequestsecp',
  labListEndPoint: '/eyefinity-labs/lablists',
  accountNumbersEndPoint: '/eyefinity-labs/accountnumbers',
};
